import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["item"]

  connect() {
    this.equalizeGroups()
    window.addEventListener('resize', this.equalizeGroups.bind(this));
  }

  disconnect() {
    window.removeEventListener('resize', this.equalizeGroups.bind(this));
  }

  equalizeGroups() {
    const groups = {};

    this.itemTargets.forEach(item => {
      
      const groupName = item.dataset.equalizitGroup;
      if (groupName) {
        if (!groups[groupName]) {
          groups[groupName] = [];
        }
        groups[groupName].push(item);
      }
    });

    for (const groupName in groups) {
      this.equalizeHeights(groups[groupName]);
    }
  }

  equalizeHeights(group) {
    let maxHeight = 0;

    group.forEach(element => {
      if (element) {
        element.style.height = 'auto';
        maxHeight = Math.max(maxHeight, element.offsetHeight);
      }
    });

    group.forEach(element => {
      if (element) {
        element.style.height = `${maxHeight}px`;
      }
    });
  }
}
